import React, { useState, useEffect } from "react";
import { MapPin, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function DeliveryEstimate() {
  const [pin, setPin] = useState(() => localStorage.getItem("delivery_pincode") || "");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const check = async (value) => {
    const p = (value ?? pin).trim();
    if (p.length !== 6 || !/^\d+$/.test(p)) { setError("Enter a valid 6-digit PIN code"); setResult(null); return; }
    setLoading(true); setError("");
    try {
      const r = await api.deliveryEstimate(p);
      setResult(r);
      localStorage.setItem("delivery_pincode", p);
    } catch (err) {
      setError(err.message); setResult(null);
    } finally { setLoading(false); }
  };

  useEffect(() => {
    if (pin.length === 6) check(pin);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="mt-4 rounded-xl border border-line p-4" data-testid="delivery-estimate">
      <div className="flex items-center gap-2 mb-2"><MapPin className="text-brand" size={18} /><span className="text-sm font-semibold text-ink">Check delivery time</span></div>
      <div className="flex gap-2">
        <input value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 6))} placeholder="Enter PIN code" className="flex-1 h-11 rounded-lg border border-line px-3 text-sm focus:outline-none focus:border-brand" data-testid="pincode-input" />
        <button onClick={() => check()} disabled={loading} className="h-11 px-5 rounded-lg bg-ink text-white text-sm font-semibold flex items-center gap-1.5 disabled:opacity-60" data-testid="pincode-check">
          {loading ? <Loader2 className="animate-spin" size={16} /> : "Check"}
        </button>
      </div>
      {error && <p className="text-xs text-err mt-2">{error}</p>}
      {result && (
        <div className="mt-3 text-sm text-ink/80" data-testid="pincode-result">
          <p>Delivering to <span className="font-semibold text-ink">{result.district ? `${result.district}, ${result.state}` : result.state || "your area"}</span></p>
          <p className="text-brand font-semibold mt-0.5">Estimated {result.from_date} – {result.to_date}</p>
        </div>
      )}
    </div>
  );
}
